import { render, staticRenderFns } from "./project-list.vue?vue&type=template&id=2a7d65ea&scoped=true"
import script from "./project-list.vue?vue&type=script&lang=js"
export * from "./project-list.vue?vue&type=script&lang=js"
import style0 from "./project-list.vue?vue&type=style&index=0&id=2a7d65ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7d65ea",
  null
  
)

export default component.exports